import Typography, { ITypographyHeadingVariants } from 'components/typography';
import { sanitizeAndParseHtml } from 'utils/rich-text-renderer/sanitize-and-parse';
import styles from './step-by-step-card.module.scss';

interface IStepByStepCardProps {
	title: string | undefined;
	description?: string | undefined;
	backgroundColor: string | undefined;
	headingType?: ITypographyHeadingVariants;
}

const StepByStepCard = (props: IStepByStepCardProps): React.JSX.Element => {
	const background = props.backgroundColor === 'white' ? styles.grey : props.backgroundColor === 'grey' && styles.white;

	return (
		<div className={`${styles.card} ${background}`}>
			<Typography tag={props.headingType || 'div'} variant="h3" className={styles.title} id={props.title}>
				{props.title}
			</Typography>
			<div className={styles.description}>{props.description && sanitizeAndParseHtml(props.description)}</div>
		</div>
	);
};

export { StepByStepCard };
